import React from "react";
import PropTypes from "prop-types";
import { stringToColor } from "../../components/CalendarCalendar/calendarHelpers";
import { isUnknownContact, getInitials } from "./messageCenterHelpers";
import styles from "./Avatar.module.css";

/**
 * Avatar circular do contato.
 *
 *  - Contato conhecido → iniciais sobre cor determinística por hash do nome
 *    (mesma lógica do calendário, via `stringToColor`).
 *  - Contato desconhecido → ícone genérico de pessoa sobre fundo cinza.
 *
 * NOTA: foto por URL é inviável — o backend não expõe `profilePicUrl` no
 * `ChatSession`. Por isso este componente nunca renderiza `<img>`.
 *
 * `humanControl` adiciona um ponto vermelho no canto (controle humano ativo).
 */
export default function Avatar({ name, size = "md", humanControl = false }) {
  const unknown = isUnknownContact(name);
  const dimension = size === "sm" ? 34 : size === "lg" ? 48 : 42;
  const fontSize = size === "sm" ? "0.8rem" : size === "lg" ? "1.05rem" : "0.95rem";

  const style = unknown
    ? { width: dimension, height: dimension, background: "#cbd5e1" }
    : {
        width: dimension,
        height: dimension,
        background: stringToColor(name),
        fontSize,
      };

  return (
    <span className={styles.wrapper} style={{ width: dimension, height: dimension }}>
      <span className={styles.avatar} style={style} aria-hidden="true">
        {unknown ? "👤" : getInitials(name)}
      </span>
      {humanControl && <span className={styles.dot} aria-hidden="true" />}
    </span>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  humanControl: PropTypes.bool,
};
